import { useAuth } from "@Auth/useAuth";
import { ComplexPageHeader } from "@common/ComplexPage/ComplexPageHeader";
import {
  TableContainer,
  ViewAllContainer,
  ViewAllHeader,
} from "@Layout/ViewAllLayout/Components";
import { TableLoadingIndicator } from "@Layout/ViewAllLayout/TableLoadingIndicator";
import { Box, Divider, Typography } from "@mui/material";
import { useProductStagesStore } from "@stores/productStagesStore";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useMemo } from "react";
import { ColDef } from "ag-grid-community";
import { NoContentCard } from "@common/ComplexPage/NoContentCard";
import { DRAWER_CONTEXT } from "@models/DrawerContext";
import { useSideDrawerStore } from "@stores/sideDrawerStore";

type RowDataType = {
  name: string;
  description: string;
};

export const Stages = () => {
  const { getStages, stages, loading } = useProductStagesStore();
  const { baseUser } = useAuth();

  const { handleOpen, setContext } = useSideDrawerStore();

  useEffect(() => {
    if (!baseUser) return;
    getStages(baseUser.organization_id!);
  }, [baseUser, getStages]);

  const columnDefs = useMemo<ColDef<RowDataType>[]>(
    () => [
      { field: "name", headerName: "Name" },
      { field: "description", headerName: "Description" },
    ],
    []
  );

  const rowData = useMemo(() => {
    return stages.map((stage) => ({
      id: stage.id,
      name: stage.name,
      description: stage.description || "",
    }));
  }, [stages]);

  return (
    <ViewAllContainer>
      <ViewAllHeader>
        <Typography variant="h3">Stages</Typography>
      </ViewAllHeader>
      <ComplexPageHeader
        buttonText="Add Stage"
        onClick={() => {
          setContext(DRAWER_CONTEXT.CREATE_STAGE);
          handleOpen();
        }}
        searchValue={""}
        setSearchValue={() => {}}
      />
      <Divider color="black" />
      {loading && <TableLoadingIndicator />}
      {!loading && (
        <>
          {rowData.length === 0 ? (
            <NoContentCard
              title="No stages"
              description="Add a stage to get started"
              buttonText="Add Stage"
              onClick={() => {
                setContext(DRAWER_CONTEXT.CREATE_STAGE);
                handleOpen();
              }}
            />
          ) : (
            <TableContainer>
              <Box
                sx={{
                  width: "100%",
                  "& .ag-root-wrapper": {
                    // border: 'none',
                  },
                  "& .ag-root": {
                    // border: 'none',
                  },
                  "& .ag-body": {
                    height: "auto !important",
                  },
                  "& .ag-center-cols-container": {
                    minHeight: "0 ",
                  },
                  "& .ag-center-cols-viewport": {
                    height: "auto !important",
                    minHeight: "46px !important",
                  },
                }}
              >
                <div
                  className="ag-theme-material"
                  style={{
                    width: "100%",
                  }}
                >
                  <AgGridReact<RowDataType>
                    rowData={rowData}
                    columnDefs={columnDefs}
                    domLayout="autoHeight"
                    suppressScrollOnNewData={true}
                    rowHeight={46}
                    headerHeight={46}
                    //   onRowClicked={(params) => {
                    //     if (!params.data || !('id' in params.data)) {
                    //       onErrorShow(
                    //         'No data found, please try again, if the error persists contact support'
                    //       );
                    //       return;
                    //     }
                    //     setContext(DRAWER_CONTEXT.EDIT_STOCK);
                    //     handleOpen();
                    //     setSelectedId(params.data.id as string);
                    //   }}
                    defaultColDef={{
                      sortable: true,
                      filter: true,
                      resizable: true,
                      flex: 1,
                    }}
                  />
                </div>
              </Box>
            </TableContainer>
          )}
        </>
      )}
    </ViewAllContainer>
  );
};
